export default __webpack_public_path__ + "static/media/pancreas_plot_female.501006c7.png";